import { some } from 'lodash';

import { EnumUserRelationshipsType, EnumUserRole, User } from './graphql';

export function isAdmin(user: User) {
  return user?.role === EnumUserRole.Admin;
}

export function isProcessor(user: User) {
  return (
    user?.role === EnumUserRole.Admin ||
    user?.role === EnumUserRole.VendorOwner ||
    user?.role === EnumUserRole.Vendor
  );
}

export function isProducer(user: User) {
  return user?.role === EnumUserRole.Basic;
}

export function isVendorOwner(user: User) {
  return (
    user?.role === EnumUserRole.Admin || user?.role === EnumUserRole.VendorOwner
  );
}

export function isBuyer(user: User) {
  return (
    user?.role === EnumUserRole.Basic &&
    some(
      user?.relationships,
      (r) => r?.type === EnumUserRelationshipsType.Buyer,
    )
  );
}

export function isBuyerOnly(user: User) {
  return (
    isBuyer(user) &&
    !some(
      user?.relationships,
      (r) => r?.type === EnumUserRelationshipsType.Producer,
    )
  );
}
